module.exports = __webpack_public_path__ + "static/img/logo.08d476c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logisticsBigData/logo.png
// module id = CvB1
// module chunks = 44